'use client';
import { jsx } from 'react/jsx-runtime';
import { useContext, useEffect, useState, useMemo, createContext } from 'react';
import { useNonNullishContext } from '../../../hooks/use-non-nullish-context.js';

function _define_property(e, t, o) {
    return t in e ? Object.defineProperty(e, t, {
        value: o,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = o, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var o = null != arguments[t] ? arguments[t] : {}, n = Object.keys(o);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function(e) {
            return Object.getOwnPropertyDescriptor(o, e).enumerable;
        }))), n.forEach(function(t) {
            _define_property(e, t, o[t]);
        });
    }
    return e;
}
const FloatingLabelContext = createContext(null);
const useFloatingLabelContext = ()=>useContext(FloatingLabelContext);
const useNonNullishFloatingLabelContext = ()=>useNonNullishContext(FloatingLabelContext);
function FloatingLabelContextProvider({ children: t }) {
    let [o, n] = useState(), a = useMemo(()=>({
            inputId: o,
            setInputId: n
        }), [
        o,
        n
    ]);
    return jsx(FloatingLabelContext.Provider, {
        value: a,
        children: t
    });
}
function useFloatingLabelFormElement(e) {
    let { id: t } = e, o = useFloatingLabelContext(), r = null == o ? void 0 : o.setInputId;
    return useEffect(()=>{
        if (void 0 !== r) return r(t), ()=>{
            r(void 0);
        };
    }, [
        t,
        r
    ]), e;
}
function useFloatingLabelTextInputElement(e) {
    let t = useFloatingLabelContext(), o = _object_spread({}, e);
    if (t) {
        var n;
        o.placeholder = null !== (n = e.placeholder) && void 0 !== n ? n : ' ';
    }
    return useFloatingLabelFormElement(o);
}
function useFloatingLabelProps() {
    let { inputId: e } = useNonNullishFloatingLabelContext();
    return {
        htmlFor: e
    };
}

export { FloatingLabelContext, FloatingLabelContextProvider, useFloatingLabelContext, useFloatingLabelFormElement, useFloatingLabelProps, useFloatingLabelTextInputElement, useNonNullishFloatingLabelContext };
